export const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://dragon-fit.vercel.app';

const buildHeaders = (options) => {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return headers;
};

// In-flight refresh promise so parallel 401s share a single refresh call.
let refreshInFlight = null;

const tryRefreshToken = () => {
  if (refreshInFlight) return refreshInFlight;
  const token = localStorage.getItem("token");
  if (!token) return Promise.resolve(false);

  refreshInFlight = fetch(`${API_URL}/api/auth/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    credentials: "include",
  })
    .then(async (res) => {
      if (!res.ok) return false;
      const data = await res.json().catch(() => ({}));
      if (data?.token) {
        localStorage.setItem("token", data.token);
        return true;
      }
      return false;
    })
    .catch(() => false)
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
};

export const apiFetch = async (endpoint, options = {}) => {
  const isRefreshCall = endpoint === "/api/auth/refresh";

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: buildHeaders(options),
  });

  if (response.status !== 401 || isRefreshCall) return response;

  const refreshed = await tryRefreshToken();
  if (!refreshed) return response;

  // Retry the original request with the new token.
  return fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: buildHeaders(options),
  });
};
